module.exports = __webpack_public_path__ + "static/media/houndstooth_logo.cc17c40d.png";